import http from '@shared/http';
import { COSMOS_V2_URL } from '@shared/const';
import {
  KYCApplicant,
  KYCCountry,
  KYCData,
  SubmitVault,
  UpdateKycData
} from '@huspy/forge/types';
import {
  VaultConfigMutationPayload,
  VaultConfig,
  VaultProgress,
  PublicVaultData
} from './types';

export const vaultApi = {
  createVault: async (
    oppId: string
  ) => http.post(`${COSMOS_V2_URL}/vaults/${oppId}/config`, { opportunity_id: oppId }),
  getKYCData: <TCountry extends KYCCountry = 'AE'>(opportunityId: string) =>
    http.get<KYCData<TCountry>>(
      `${COSMOS_V2_URL}/vaults/${opportunityId}/applicants`
    ),
  updateKYCData: <TCountry extends KYCCountry = 'AE'>(
    opportunityId: string,
    applicantId: string,
    body: UpdateKycData<TCountry>
  ) =>
    http.post(
      `${COSMOS_V2_URL}/vaults/${opportunityId}/applicants/${applicantId}`,
      body
    ),
  updateVault: (oppId: string, { selected_banks, applicants }: VaultConfigMutationPayload) =>
    http.update(`${COSMOS_V2_URL}/vaults/${oppId}/config`, {
      opportunity_id: oppId,
      selected_banks,
      applicants,
    }),
  setVaultPassCode: (oppId: string, { passcode }: { passcode: string }) =>
    http.post(`${COSMOS_V2_URL}/vaults/${oppId}/passcode`, { passcode }),
  getVaultConfig: (oppId: string) =>
    http.get<VaultConfig>(`${COSMOS_V2_URL}/vaults/${oppId}/config`),
  getVaultOverview: (opportunityId: string) => http.get<VaultProgress>(`${COSMOS_V2_URL}/vaults/${opportunityId}/overview`),
  getPublicVaultData: (opportunityId: string) =>
    http.get<PublicVaultData>(
      `${COSMOS_V2_URL}/vaults/${opportunityId}/public`,
      {},
      {},
      undefined,
      false
    ),
  getVaultStorage: (opportunityId: string) =>
    http.get<{
      vault_data_json: { applicants: KYCApplicant[] },
      vault_status: 'draft' | 'submitted' | 'disabled'
    }>(`${COSMOS_V2_URL}/vaults/${opportunityId}/vault_storage`),
  createVaultStorage: (
    opportunityId: string
  ) =>
    http.post(`${COSMOS_V2_URL}/vaults/${opportunityId}/vault_storage`, null),
  submitVault: <TCountry extends KYCCountry = 'AE'>(
    opportunityId: string,
    body: SubmitVault<TCountry>
  ) =>
    http.post(
      `${COSMOS_V2_URL}/vaults/${opportunityId}/applicants/bulk`,
      body
    ),
};
